import React from "react";

import { createMedia } from "@artsy/fresnel"
import MobileComponent from "./MobileComponent";
import DesktopComponent from "./DesktopComponent";


const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    sm: 0,
    lg: 1080,
  },
})
 
const Home = () => {
    return (
        <MediaContextProvider>
          <Media at="sm">
            <MobileComponent />
          </Media>
          <Media greaterThanOrEqual="lg">
            <DesktopComponent/>
          </Media>
        </MediaContextProvider>
    );
}

export default Home;